'use client'

import Link from 'next/link'
import { IconDefinition } from '@document-crunch/pro-regular-svg-icons'
import { cn } from '@dc-shared-web/lib'
import { Icon, IconColor } from '@dc-shared-web/components/base/Icon'
import { Tooltip } from '@dc-shared-web/components/base/Tooltip'
import { ReactNode } from 'react'

interface SideBarNavItemProps {
  href: string
  icon: IconDefinition
  children: ReactNode
  className?: string
  isActive?: boolean
  onClick?: () => void
}

export function SideBarNavItem({
  href,
  icon,
  children,
  className,
  isActive,
  ...rest
}: SideBarNavItemProps) {
  return (
    <Tooltip className='md:tw-hidden' content={children} side='right' withArrow>
      <Link
        {...rest}
        href={href}
        data-active={isActive}
        className={cn(
          'tw-inline-flex tw-items-center tw-h-10 [&_svg]:tw-size-4 tw-px-3 tw-py-2 tw-rounded-md hover:tw-bg-neutral-100',
          isActive && 'tw-bg-neutral-100',
          className
        )}
      >
        <Icon icon={icon} color={IconColor.darkPrimary} className='tw-mr-4' />
        <span className='tw-hidden md:tw-inline'>{children}</span>
      </Link>
    </Tooltip>
  )
}
